import { actionOnMessage } from '@skynet/data-ws-mm';
import type { BalancesState } from './types';
import { addBalance, createBalancesSnapshot, createSnapshots } from './actions';
import { listen as listenLoans } from 'src/store/loans/actions';
import { listen as listenRetainers } from 'src/store/retainers/actions';
import { createBalancesSlice } from './factory';

export const initialState: BalancesState = {
  error: null,
  requestStatus: null,

  list: {},
  supportedTokens: {},

  selection: [],

  createBalanceSnapshotStatus: null,
  createWalletSnapshotStatus: null,
  addBalanceStatus: null,

  currentProjectId: null,

  balancesCorrection: {
    open: false,
    data: null,
  },
};

const Balances = createBalancesSlice({
  prefix: 'shared',
  sliceName: 'balances',
  messages: actionOnMessage,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(listenLoans, (state, action) => {
      const { section } = action.payload;
      const { isInitCall } = action.meta;
      if (section === 'balances' && isInitCall) {
        state.requestStatus = 'pending';
      }
    });

    builder.addCase(listenRetainers, (state, action) => {
      const { section } = action.payload;
      const { isInitCall } = action.meta;
      if (section === 'balances' && isInitCall) {
        state.requestStatus = 'pending';
      }
    });

    builder.addCase(createBalancesSnapshot, (state) => {
      state.createBalanceSnapshotStatus = 'pending';
      state.addBalanceStatus = null;
    });

    builder.addCase(createSnapshots.pending, (state) => {
      state.createWalletSnapshotStatus = 'pending';
      state.addBalanceStatus = null;
    });

    builder.addCase(createSnapshots.fulfilled, (state) => {
      state.createWalletSnapshotStatus = 'success';
    });

    builder.addCase(createSnapshots.rejected, (state) => {
      state.createWalletSnapshotStatus = 'error';
    });

    builder.addCase(addBalance.pending, (state) => {
      state.addBalanceStatus = 'pending';
      state.createBalanceSnapshotStatus = null;
      state.createWalletSnapshotStatus = null;
    });
  },
});

export const balancesActions = {
  ...Balances.actions,
  addBalance,
  createBalancesSnapshot,
  createSnapshots,
};

export default Balances.reducer;
